module.exports = __webpack_public_path__ + "img/Partners 1.1ca8486d.png";